var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"base-loader",style:(("--p-height: " + _vm.height + "px")),attrs:{"column":"","align-center":"","justify-center":""}},[_c('img',{attrs:{"src":require("../../assets/icons/course.png"),"alt":"logo","width":"auto","height":"160px"}}),_vm._v(" "),_c('div',{staticClass:"text-message mt-3"},[_vm._v(_vm._s(_vm.infoText))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8175b4a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/InfoBase.vue
// module id = 9FaS
// module chunks = 38